  $(window).scroll(function(){
        if ($(window).scrollTop() >=100) {
           $('.site-header').addClass('fixed-header');
        }
        else {
           $('.site-header').removeClass('fixed-header');
        }
});

$(document).ready(function() {
    $('.hide-div i').on('click', function(e) { $(e.target).closest('.hide-div').remove(); });
});